import { useEffect, useState } from 'react'

interface CalendarIconProps {
    date?: Date
}

const CalendarIcon: React.FC<CalendarIconProps> = ({ date }) => {
    const [value, setValue] = useState(() => new Date().getDate())

    useEffect(() => {
        if (date) {
            setValue(date.getDate())
        }
    }, [date])

    return (
        <svg width="25" height="31" viewBox="0 0 25 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_46168_19078)">
                <path
                    d="M20.58 5H4C2.34315 5 1 6.34315 1 8V26.31C1 27.9669 2.34315 29.31 4 29.31H20.58C22.2369 29.31 23.58 27.9669 23.58 26.31V8C23.58 6.34315 22.2369 5 20.58 5Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path d="M7 1V9" stroke="white" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
                <path d="M17.5801 1V9" stroke="white" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
                <text
                    x="50%"
                    y="60%"
                    dominantBaseline="middle"
                    textAnchor="middle"
                    fontSize="12"
                    fill="white"
                    fontWeight="bold"
                >
                    {value}
                </text>
            </g>
            <defs>
                <clipPath id="clip0_46168_19078">
                    <rect width="24.58" height="30.31" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

CalendarIcon.displayName = 'CalendarIcon'

export default CalendarIcon
